import { z } from 'zod';
import { getAuthHeaders } from './authHeaders';
import { getCurrentGatewayUrl } from './environmentDetection';

const SerialNeoQueueSnapshotSchema = z.object({
  signalIds: z.array(z.string()),
  activeSignalId: z.string().nullable(),
});

export type SerialNeoQueueSnapshot = z.infer<
  typeof SerialNeoQueueSnapshotSchema
>;

export async function fetchSerialNeoQueue(
  applicationId: string,
): Promise<SerialNeoQueueSnapshot> {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(
    `${getCurrentGatewayUrl()}/ai/agents/neo/serial-queue/${encodeURIComponent(applicationId)}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: authHeaders,
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch the serial Neo queue');
  }

  return SerialNeoQueueSnapshotSchema.parse(await response.json());
}
